export default __webpack_public_path__ + "static/media/5-min.029710af.webp";